import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import { EntityStatus } from '@yakoffice/publisher-types';
import type { IEntityVersion } from '../model/entity/EntityVersion';
import type { IEntityVersionSearchParams } from '../api/requests/entities/entityVersionApiGateway';
import type { IExperimentProperty } from '../model/experiment/ExperimentProperty';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useExperimentEntitiesResult {
    isLoaded: boolean;
    entityVersions: IEntityVersion[];
}

export const useExperimentEntities = (experimentProperty: IExperimentProperty) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useExperimentEntitiesResult>({ isLoaded: false, entityVersions: [] });

    useEffect(() => {
        setResult({ isLoaded: false, entityVersions: [] });

        if (experimentProperty.hasValidKindId()) {
            const searchParams: IEntityVersionSearchParams = {
                kindId: experimentProperty.kindId,
                gameEnvironmentId: rootStore.gameEnvironmentsStore.getCurrentGameEnvironment().id,
                status: EntityStatus.Published
            };
            rootStore.entityVersionStore.findAllCurrentEntityVersions(searchParams)
                .then((entities) => {
                    setResult({ isLoaded: true, entityVersions: entities });
                })
                .catch(e => publishNotification({
                    text: `Error loading experiment entities ${e.message}`,
                    canClose: true
                }));
        }
    }, [rootStore.entityVersionStore, rootStore.gameEnvironmentsStore, publishNotification, experimentProperty, experimentProperty.kindId]);

    return result;
};
